import {
    useState,
    forwardRef,
    useImperativeHandle,
    useContext,
} from "react"

import ExpandableComponentContext from "../../Contexts/ExpandableComponentContext"

const OptionInput = forwardRef(({ title, data, options, valueChangeHandler, readOnly, isMandatory = true, outputType = "string", test }, ref) => {

    const ExpandableComponentData = useContext(ExpandableComponentContext)

    const isInteracted = ExpandableComponentData ? ExpandableComponentData?.isInteracted : false

    const [value, setValue] = useState(data || "")
    const [error, setError] = useState(false)

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            let validity = !isMandatory || (value ? true : false)

            if (validity) {
                setError(false)
            }
            else {
                if (isInteracted) {
                    setError(true)
                }
            }

            return {
                isValid: validity,
                value: outputType === "integer" ? Number(value) : value,
            }
        },
    }))

    return (
        <div className="my-4">
            <label className="block text-base font-medium text-gray-700 mb-4">{`${title}${isMandatory ? "*" : ""}`}</label>

            <select
                className="border border-gray-300 rounded-md p-2 bg-white w-full"
                value={value}
                disabled={readOnly}
                onChange={(e) => {
                    setValue(e.target.value)
                    valueChangeHandler?.(e.target.value)
                }}
            >
                {options.map((option) => (
                    <option key={option.title} value={option.key}>
                        {option.title}
                    </option>
                ))}
            </select>
            {error && (
                <p className="mt-1 text-sm text-red-600">
                    {title} is invalid
                </p>
            )}
        </div>
    )
})

export default OptionInput
